module.exports = __webpack_public_path__ + "static/media/ringedin.01a55605.png";